let proDescription = document.querySelector(".pro-description .page-width");

// Select all the tables inside the proDescription
let tables = proDescription.querySelectorAll("table");

tables.forEach((table) => {
    // Create a wrapper div
    let tableWrapper = document.createElement("div");
    tableWrapper.classList.add("table-wrapper");

    // Insert the wrapper before the table
    table.parentNode.insertBefore(tableWrapper, table);

    // Move the table inside the wrapper
    tableWrapper.appendChild(table);
});



